export const APPLICATION_CLIENT_CONFIGURATION_IDS: number[] = [1];